export const EXTENSION_CONFIG = {
	PRIMARY_ID: 'dbnifcdpcagninfplaagbkjkjglidena', // Local unpacked extension ID for demo
	// Production ID: 'ihcgicdogclbieclnldfjmlglkolankb'

	EXTENSION_NAME: 'LoadFetcher Extension',

	STORE_URL:
		'https://chrome.google.com/webstore/detail/ihcgicdogclbieclnldfjmlglkolankb',

	TIMEOUTS: {
		PING: 5000, // 5 seconds for ping check
		DEFAULT: 5000, // 5 seconds default
		POST_TRUCK: 15000, // 15 seconds for posting truck
	},
}

export default EXTENSION_CONFIG
